/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_Ok_DescInputs */

const en_cp_form_ok_desc = /** @type {(inputs: Cp_Form_Ok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We reply to your email within 2 working days with a suggested model, calendar, and price.`)
};

const id_cp_form_ok_desc = /** @type {(inputs: Cp_Form_Ok_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami balas ke email Anda dalam 2 hari kerja dengan usulan model, kalender, dan harga.`)
};

/**
* | output |
* | --- |
* | "We reply to your email within 2 working days with a suggested model, calendar, and price." |
*
* @param {Cp_Form_Ok_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_ok_desc = /** @type {((inputs?: Cp_Form_Ok_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_Ok_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_ok_desc(inputs)
	return en_cp_form_ok_desc(inputs)
});